/**
 * Enum to describe how the subscript messages should push content
 * Based on what is showing
 */
export enum SubscriptPushOption {
  MULTI_LINE_RESPONSIVE, // Only push content when message wraps except on the smallest viewport fallback to always
  MULTI_LINE, // Only push content when the message wraps
  NEVER, // Never push content down
  ALWAYS, // Always push content down at least one line height
}
